<template>
  <div class="relative">
    <input
        v-model="search"
        class="rounded w-full text-base h-10 px-3 mt-2 z-0"
        type="text"
        @input="onChange"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        tabindex="0" 
        autocomplete="off" 
        autocorrect="off" 
        autocapitalize="none" 
        spellcheck="false" 
        role="textbox" 
        aria-label="Location" 
        aria-autocomplete="list" 
        placeholder="Enter a location Province, Town, Suburb"
    />
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      class="absolute border border-solid border-white h-64 p-0 m-0 w-full overflow-auto bg-white z-10"
    >
      <li
        class="loading"
        v-if="isLoading"
      >
        Please wait..
      </li>
      <li
        v-else
        v-for="(result, index) in results"
        :key="index"
        @click="setResult(result)"
        class="autocomplete-result p-2 list-none text-left cursor-pointer"
        :class="{ 'is-active': index === arrowCounter }"
      >
        {{ result.title_display }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'autocomplete',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data() {
      return {
        isOpen: false,
        results: [],
        search: '',
        isLoading: false,
        arrowCounter: 0,
      };
    },
    methods: {
      onChange() {
        this.$emit('input', this.search);

        this.filterResults();
        this.isOpen = true;
      },

      filterResults() {
        this.results = this.items.filter((item) => {
          return item.title_display.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      },
      setResult(result) {
        this.search = result.title_display;
        this.isOpen = false;
        this.$emit('selectedLocation', {'locationId' : result.id, 'locationDepth' : result.depth});
      },
      onArrowDown() {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter -1;
        }
      },
      onEnter() {
        this.search = this.results[this.arrowCounter].title_display;
        this.isOpen = false;
        this.arrowCounter = -1;
        this.$emit('selectedLocation', {'locationId' : this.results[this.arrowCounter].id, 'locationDepth' : this.results[this.arrowCounter].depth});
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      }
    },
    watch: {
      items: function (val, oldValue) {
        if (val.length !== oldValue.length) {
          this.results = val;
          this.isLoading = false;
        }
      },
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    }
  };
</script>

<style>
  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #5897fb;
    color: white;
  }
</style>